import Cookies from 'js-cookie';
import $ from 'qwery';
import MegaModal from './MegaModal';

const AllergenInteractionModalMessage = {
    init (element) {
        this.defaults = {
            data: {
                allergenInteractionModalCta: 'data-allergen-interaction-modal-cta',
                allergenInteractionModalView: 'data-allergen-interaction-modal-view',
                allergenFeatureToggle: 'data-allergen-feature-toggle',
                allergenRestaurantPhoneNumber: '[data-allergen-phone-number]',
                allergenRestaurantUrl: '[data-allergen-url]'
            },
            cookies: {
                jeAllergenCookie: 'je-allergen-cta-interaction',
                jeAllergenCookieValue: 1
            },
            events: {
                click: 'click',
                warning: 'warning',
                autoWarning: 'autowarning',
                viewDialog: 'view_dialog',
                clickClose: 'click_close'
            }
        };

        if (this.isFeatureFlagEnabled(element)) {
            const allergenCtaButtons = $(`button[${this.defaults.data.allergenInteractionModalCta}]`);
            this.bindEvents(allergenCtaButtons);
            this.showModalInstance(`[${this.defaults.data.allergenInteractionModalView}]`);
        }
    },
    isFeatureFlagEnabled (element) {
        return document.querySelector(element) && document.querySelector(element)
            .getAttribute(this.defaults.data.allergenFeatureToggle) === 'true';
    },
    isModalContextAvailable (modalContext) {
        return !!modalContext;
    },
    setUsersState () {
        Cookies.set(
            this.defaults.cookies.jeAllergenCookie,
            this.defaults.cookies.jeAllergenCookieValue
        );
    },
    isAllergenInteractionActive () {
        return Cookies.get(this.defaults.cookies.jeAllergenCookie) === '1';
    },
    isRestaurantContactInformationAvailable (element) {
        return document.querySelector(element);
    },
    showModalInstance (element) {
        if (
            document.querySelector(element)
            && this.isModalContextAvailable(this.getModalInstance())
            && this.isAllergenInteractionActive()
        ) {
            this.getModalInstance().show();

            this.trackAllergenRestaurantPhoneNumberEvent();
            this.trackAllergenRestaurantUrlEvent();
        }
    },
    getModalInstance () {
        return new MegaModal({
            modalType: 'narrow',
            content: `[${this.defaults.data.allergenInteractionModalView}]`,
            clickOutsideToClose: 'false',
            onHide: () => this.trackEvents(
                `dialog_allergens_${this.defaults.events.warning}`,
                this.defaults.events.clickClose
            )
        });
    },
    trackAllergenRestaurantPhoneNumberEvent () {
        const phoneNumberValue = this.isRestaurantContactInformationAvailable(this.defaults.data.allergenRestaurantPhoneNumber)
            ? 'phone'
            : 'nophone';

        this.trackEvents(
            `dialog_allergens_${this.defaults.events.warning}_${phoneNumberValue}`,
            this.defaults.events.viewDialog
        );
    },
    trackAllergenRestaurantUrlEvent () {
        const urlValue = this.isRestaurantContactInformationAvailable(this.defaults.data.allergenRestaurantUrl)
            ? 'url'
            : 'nourl';

        this.trackEvents(
            `dialog_allergens_${this.defaults.events.warning}_${urlValue}`,
            this.defaults.events.viewDialog
        );
    },
    bindEvents (elements) {
        elements.forEach(element => {
            element.addEventListener(this.defaults.events.click, () => {
                this.setUsersState();

                this.trackAllergenRestaurantPhoneNumberEvent();
                this.trackAllergenRestaurantUrlEvent();
            });
        });
    },
    trackEvents (eventAction, eventLabel) {
        window.dataLayer = window.dataLayer || [];

        const events = {
            eventCategory: 'engagement',
            eventAction,
            eventLabel
        };

        window.dataLayer.push(events);
    }
};

export default AllergenInteractionModalMessage;
